/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_MarkersInputs */



/**
* | output |
* | --- |
* | "Markers" |
*
* @param {Quicktools_Tab_MarkersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_markers = /** @type {((inputs?: Quicktools_Tab_MarkersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_MarkersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Markierungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Marcatori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Маркеры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcadores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्करों")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Marcadores")
	return /** @type {LocalizedString} */ ("Markers")
});